export default __webpack_public_path__ + "static/media/AxisLogo.f89da7c8.png";